import type { IListResponse, INews, IPage } from '@dakedake/types'
import { request } from '@umijs/max'

/** 获取新闻详情 GET /backend/news/:id */
export async function newsDetail(options?: Record<string, any>) {
  return request<{ data: INews }>('/backend/news/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取是否有重名 GET /backend/news/getName */
export async function newsName(params: { name: string, id?: number }) {
  return request<{ data: INews }>('/backend/news/getName', {
    method: 'GET',
    params
  })
}

/** 获取新闻列表 GET /backend/news/list */
export async function newsList(params: IPage) {
  return request<IListResponse<INews>>('/backend/news/list', {
    method: 'GET',
    params: {
      ...params
    }
  })
}

/** 添加/编辑新闻 POST /api/news/add */
export async function newsAdd(body: INews) {
  return request<{ data: INews, status: number, message: string }>('/backend/news/add', {
    method: 'POST',
    data: body
  })
}

/** 删除新闻 DELETE /api/news/delete */
export async function newsDelete(body: { id?: number }) {
  return request<{ data: number }>('/backend/news/delete', {
    method: 'DELETE',
    body
  })
}
